import { TermScheduleFlags } from '../../course_scheduler/services/term_schedule_flags';
import { ISection, IConflictMessage, ISectionAvailability } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionStatus } from '../../course_scheduler/types/scheduled_section_status_enum';
import * as _4 from 'lodash4';
export class UnscheduledSectionServant {
  constructor(private ngTermScheduleFlags: TermScheduleFlags) {}
  isSectionFull(unscheduledSection: ISection) {
    return (
      !this.isSectionConflicting(unscheduledSection) &&
      !_4.isUndefined(unscheduledSection._availability) &&
      !unscheduledSection._availability.is_seat_available
    );
  }
  isSectionConflicting(unscheduledSection: ISection) {
    return _4.isUndefined(unscheduledSection._availability)
      ? false
      : unscheduledSection._availability.is_conflicting_with_linked_section ||
          unscheduledSection._availability.is_conflicting_with_selected_section ||
          unscheduledSection._availability.is_conflicting_with_student_time ||
          unscheduledSection._availability.is_conflicting_with_student_campus;
  }
  isSectionConflictingWithBusyTimes(unscheduledSection: ISection) {
    return _4.get(unscheduledSection, '_availability.is_conflicting_with_student_time', false);
  }
  isSectionConflictingWithCampusPreferences(unscheduledSection: ISection) {
    return _4.get(unscheduledSection, '_availability.is_conflicting_with_student_campus', false);
  }
  isSectionAvailable(unscheduledSection: ISection) {
    const sectionAvailability: ISectionAvailability = _4.get(unscheduledSection, '_availability');
    const isSectionConflicting = this.isSectionConflicting(unscheduledSection);
    return (
      !isSectionConflicting &&
      sectionAvailability &&
      sectionAvailability.is_seat_available &&
      !sectionAvailability.is_withdrawn
    );
  }
  hasWaitlist(section: ISection) {
    return section._availability.is_waitlist_allowed;
  }
  isWaitlistFull(section: ISection) {
    return section._availability.is_waitlist_allowed && section._availability.is_waitlist_full;
  }
  isWaitlisted(section: ISection) {
    return section.status === ScheduledSectionStatus.WAITLISTED;
  }
  canAddToWaitlist(section: ISection) {
    // waitlist feature enabled && is Full Section && has waitlist && is waitlist full?
    return (
      this.ngTermScheduleFlags.isWaitlistEnabled() &&
      this.isSectionFull(section) &&
      !this.isWaitlisted(section) &&
      this.hasWaitlist(section) &&
      !this.isWaitlistFull(section)
    );
  }
  allowedToScheduledFullSections(section: ISection) {
    return this.ngTermScheduleFlags.isFullSectionsSchedulingEnabled();
  }
  isOnlineSection(section: ISection) {
    return _4.get(section, '_campus.is_online', false);
  }

  canDragToSchedule(section: ISection) {
    return (
      this.isSectionAvailable(section) &&
      (!this.isSectionFull(section) || (this.isSectionFull(section) && this.canAddToWaitlist(section)))
    );
  }
  canDragSection(section: ISection) {
    if (this.isConflictingAndNotAllowedToSchedule(section)) {
      return false;
    } else if (this.allowedToScheduledFullSections(section) && this.isSectionFull(section)) {
      return true;
    } else if (
      !this.allowedToScheduledFullSections(section) &&
      this.isSectionFull(section) &&
      !this.canAddToWaitlist(section)
    ) {
      return false;
    } else {
      return true;
    }
  }

  getSectionAvailabilityText(availableTimes: number, threshold: number, divider: boolean = false) {
    const areAvailableSectionsGreaterThanThreshold = availableTimes > threshold;
    const hasSectionsAvailable = availableTimes > 0;
    const plural = availableTimes > 1 ? 's' : '';
    const pipeDivider = divider ? `| ` : ``;

    if (areAvailableSectionsGreaterThanThreshold) {
      return hasSectionsAvailable ? `${pipeDivider}${threshold}+ available time${plural}` : ``;
    } else {
      return hasSectionsAvailable
        ? `${pipeDivider}${availableTimes}  available time${plural}`
        : `${pipeDivider}no times available`;
    }
  }
  private isConflictingAndNotAllowedToSchedule(unscheduledSection: ISection) {
    return (
      unscheduledSection._availability.is_conflicting_with_linked_section ||
      unscheduledSection._availability.is_conflicting_with_selected_section
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/servants/unscheduled_section_servant.ts